export const increment = () => ({
  type: "StateTrue",
});
export const decrement = () => ({
  type: "StateFalse",
});
export const active = () => ({
  type: "appear",
});
